import { uniqueKey } from 'global/common/keys';
import MiniSwipe from 'global/components/swipers/MiniSwipe';
import _ from 'lodash';
import { useContext, useEffect, useMemo, useReducer } from 'react';
import { FrameworkContext } from '../cnr/contexts/FrameworkContent';
import { SettingParentContext } from '../cnr/contexts/SettingParentContext';
import { SettingsAreaContext } from '../cnr/contexts/SettingsAreaContext';
import { ViewSettingsContext } from '../cnr/contexts/ViewSettingsContext';
import { frameworkRightTypes } from '../cnr/reducers/FrameworkReducer';
import { viewSettingsComponentHandlers, viewSettingsComponentInitialState, viewSettingsComponentReducer } from '../cnr/reducers/ViewSettingsComponentReducer';
/**
 * Toggles with a swipe between settings
 * @param {*} props 
 * @returns SwiperWithButtons with the swipedElements within the component_state
 */
const ViewSettingsSwiper = (props) => {

  console.log('>>> ViewSettingsSwiper')

  const { trueSolo, ncProps } = props ?? {}

  const settingsParentContext = useContext(SettingParentContext)
  const { states, settings } = settingsParentContext ?? {}
  const { global_state, appSettings_state } = states ?? {}
  const { homeSettings } = settings ?? {}
  const { global: homeSettings_global } = homeSettings ?? {}
  const { logging } = homeSettings_global ?? {}
  const { settings_globalPageItems } = global_state ?? {}
  const { pageSettingsPage } = appSettings_state ?? {}

  // frameworkContext
  const frameworkContext = useContext(FrameworkContext);
  const { framework_state } = frameworkContext ?? {}
  const { frameworkRightType } = framework_state ?? {}

  // settingsAreaContext
  const settingsAreaContext = useContext(SettingsAreaContext)

  // viewSettingsContext 
  const viewSettingsContext = useContext(ViewSettingsContext);
  let { keyy, viewSettings_state } = viewSettingsContext ?? {}
  let { selectedItem, startSwipeItems, settings_temp, settingsStatus } = viewSettings_state

  if (!keyy) {
    if (selectedItem && selectedItem.key) {
      keyy = 'sgwc-' + selectedItem.key
    } else {
      keyy = 'sgwc'
    }
  }

  const swipeToSelected = (swipeProps) => vsc_handlers.swipeToItem(swipeProps)

  const addHelp = (viType) => {
    if (viType) {
      vsc_handlers.addHelp(viType)
    } else {
      vsc_handlers.addHelp()
    }
  }

  const componentContexts = { settingsParentContext, settingsAreaContext, viewSettingsContext }
  const initProps = { componentContexts, logging, addHelp, swipeToSelected, settings_globalPageItems, startSwipeItems, ncProps }
  const [vsc_state, component_dispatch] = useReducer(viewSettingsComponentReducer, viewSettingsComponentInitialState(initProps));
  const vsc_handlers = viewSettingsComponentHandlers(component_dispatch)

  // swipedElements are already formed at this point.
  const { swipedElements, selectedIndex } = vsc_state ?? {}

  // useEffect(() => {
  //   settings_temp && vsc_handlers.updateSettingsTemp(settings_temp)
  //   // eslint-disable-next-line
  // }, [settings_temp, settingsStatus]);

  useEffect(
    () => {
      if (frameworkRightType) {
        switch (frameworkRightType) {
          case frameworkRightTypes.settings:
            // nothing
            break;
          default:
            const si = {
              caption: _.startCase(pageSettingsPage),
              isActive: true,
              key: pageSettingsPage,
              show: true,
              showDesktop: true,
              vit: pageSettingsPage
            }
            const swipeProps = { swipedItem: si }
            swipeToSelected(swipeProps)
        }
      }
    },
    // update if appUser or settingsDocName changes
    // eslint-disable-next-line react-hooks/exhaustive-deps 
    [frameworkRightType]
  )

  const handleSwipeChangeIndex = (index) => vsc_handlers.setSelectedIndex(index)

  const swipeableContent = useMemo(() => {
    return <MiniSwipe
      swipeItems={swipedElements}
      handleIndexChange={handleSwipeChangeIndex}
      currentIndex={selectedIndex}
      key={uniqueKey('vss', 'sv')}
      origin={'ViewSettingsSwiper'}
      className='rsvs vss'
      noSwiping={true}
    />

  }, [swipedElements])

  return swipeableContent

}

export default ViewSettingsSwiper